import { BrowserRouter } from "react-router-dom";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from "react-helmet-async";
import './index.css';
import './responsive-theme.css';
import './responsive-utilities.css';
import './responsive-navbar.css';
import './responsive-cameriere.css';
import './responsive-menuview.css';
import './responsive-adminlocali.css';
import './responsive-gestore.css';

import './theme.css'; // 👈 METTILO PER ULTIMO

import App from './App';
import AppWaiter from './AppWaiter';
import AppKitchen from './AppKitchen';

window.onerror = function (msg, url, line, col, err) {
  const messaggio = String(msg || "");

  // Safari può restituire errori generici da script esterni
  if (
    messaggio === "Script error." ||
    (!url && Number(line) === 0 && Number(col) === 0)
  ) {
    console.warn("Errore generico ignorato:", {
      messaggio,
      url,
      line,
      col,
      err
    });

    return true;
  }

  console.error("Errore JavaScript:", {
    messaggio,
    url,
    line,
    col,
    err
  });

  return false;
};

window.onunhandledrejection = function (event) {
  console.error(
    "Promise non gestita:",
    event.reason || "Errore sconosciuto"
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const role = process.env.REACT_APP_ROLE;


let AppToRender = App;

if (role === 'waiter') {
  AppToRender = AppWaiter;
}

if (role === 'kitchen') {
  AppToRender = AppKitchen;
}

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <AppToRender />
    </BrowserRouter>
  </HelmetProvider>
);

// Registra il service worker Firebase solo nel browser reale
const isReactSnap =
  navigator.userAgent === "ReactSnap" ||
  navigator.userAgent.includes("HeadlessChrome") ||
  window.__REACT_SNAP__;

if ("serviceWorker" in navigator && !isReactSnap) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      console.log("✅ Firebase Messaging SW registrato:", reg.scope);
    } catch (err) {
      console.warn("Service Worker non registrato:", err?.message || err);
    }
  });
}